/* istanbul ignore file */
import React from 'react';
import useUnlinkedCrmActivitiesService from 'domain/sales/unlinkedEmails/shared/unlinkedCrmActivitiesService';
import useCrmUnlinkedActivityRegistry from 'domain/sales/unlinkedEmails/crmUnlinkedActivityRegistry';
import { TimelinePageLayout, TimelineLayout, Timeline } from 'framework/ui/timeline';
import { Show } from 'framework/show';

const UnlinkedCrmActivitiesTimelinePage = () => {
  const { searchTimelineItems, getTimelinePageById } = useUnlinkedCrmActivitiesService();

  const activityRegistry = useCrmUnlinkedActivityRegistry();

  return (
    <Show getDataMethod={() => Promise.resolve({})}>
      <Timeline
        registries={[activityRegistry] as any}
        getDataMethod={request => searchTimelineItems(request)}
        getPageByEntryIdMethod={id => getTimelinePageById(id)}
      >
        <TimelinePageLayout title="Unlinked CRM activities">
          <TimelineLayout noEntriesMessage="No entries in this opportunity timeline yet." />
        </TimelinePageLayout>
      </Timeline>
    </Show>
  );
};

export default UnlinkedCrmActivitiesTimelinePage;
